import { start as startPartnerDetection } from "./partner-detection.js";
import { start as startNonPartnerDetection } from "./nonpartner-detection.js";
export async function start(parameters) {
    void startPartnerDetection(parameters);
    startNonPartnerDetection(parameters);
}
